export function normalizePermissionKeys(keys?: string[]): string[] {
  if (!Array.isArray(keys) || keys.length === 0) {
    return [];
  }

  const set = new Set<string>();
  for (const key of keys) {
    if (typeof key === "string") {
      const trimmed = key.trim();
      if (trimmed) {
        set.add(trimmed);
      }
    }
  }

  // Navigation in web/mobile is gated by `*.view` permissions.
  // If the backend grants a non-view action (create/edit/delete/etc),
  // we treat that as implying `view` for navigation visibility.
  for (const key of Array.from(set)) {
    const parts = key.split(".").map((p) => p.trim()).filter(Boolean);
    if (parts.length < 3) {
      continue;
    }

    const action = parts[parts.length - 1];
    if (action.toLowerCase() === "view") {
      continue;
    }

    const viewKey = [...parts.slice(0, -1), "view"].join(".");
    set.add(viewKey);
  }

  return Array.from(set);
}
